import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom"

import Sidebar from '../components/Sidebar'
import { StyledNavbar } from './Navbar.style'

import BurgerIcon from '../assets/icons/BurgerIcon'
import Logo from "../../../assets/images/main_logo.png"
import Menu from "../../../assets/icons/Menu"
import { useScrollPosition } from '../../../hooks/useScrollPosition'

export default function Navbar() {
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [expand, setExpand] = useState(false)
    const scrollPosition = useScrollPosition()



    const change = () => {
        document.body.style.overflowY = !open ? "hidden" : ""
        setOpen(p => !p)
    }
    const toHome = () => {
        navigate("/")
        window.scroll(0, 0)
        setExpand(false)
    }

    const toFeature = () => {
        navigate("/feature")
        window.scroll(0, 0)
        setExpand(false)
    }
    const toSupport = () => {
        navigate("/support")
        window.scroll(0, 0)
        setExpand(false)
    }
    const toContact = () => {
        navigate("/contact")
        window.scroll(0, 0)
        setExpand(false)
    }
    const toAbout = () => {
        navigate("/about")
        window.scroll(0, 0)
        setExpand(false)
    }

    const { pathname } = useLocation()
    return (
        <StyledNavbar className="navbar-main" expand={expand} open={open}>
            <div className='container'>
                <div className={`navbar ${scrollPosition > 900 && "fixed"}`} >
                    <div className='burger' onClick={change}>
                        <BurgerIcon />
                    </div>
                    <Sidebar change={change} open={open} />
                    <div className='back'></div>
                    <div className='main-logo' onClick={toHome} >
                        <img src={Logo} alt='Main-logo' />
                    </div>
                    <div className='front-side' onClick={() => setExpand(false)}></div>
                    <div className='nav-list'>
                        <ul className='nav-items'>
                            <li onClick={toHome} className={`nav-item + ${pathname === "/" && "active"}`}>
                                Home
                            </li>
                            <li onClick={toAbout} className={`nav-item + ${pathname === "/about" && "active"}`}>
                                About us
                            </li>
                            <li onClick={toFeature} className={`nav-item + ${pathname === "/feature" && "active"}`}>
                                Features
                            </li>

                            <li onClick={toSupport} className={`nav-item + ${pathname === "/support" && "active"}`}>
                                Support
                            </li>

                            <li onClick={toContact} className={`nav-item + ${pathname === "/contact" && "active"}`}>
                                Contact us
                            </li>
                        </ul>
                        <div className='login'>
                            <a href="https://portal.sfeldinc.com/service-login" onClick={() => setExpand(false)}>Login</a>
                        </div>
                    </div>
                    <div className='menu' onClick={() => setExpand(true)}>
                        <Menu />
                    </div>
                </div>

            </div>
        </StyledNavbar>
    )
}
